import { BehaviorSubject, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SharedService {

  platformDirection = 'ltr';

  showLoader = new BehaviorSubject<boolean>(false);
  toast: Subject<{ title: string; message?: string; type: 'info' | 'success' | 'warning' | 'error' | 'custom' }> = new Subject();

  showToast (type: 'info' | 'success' | 'warning' | 'error' | 'custom', title: string, message: string = '') {

    if (title || message &&
      (
        !(title || '').toLowerCase().includes('failed') &&
        !(message || '').toLowerCase().includes('failed')
      )
    ) {
      this.toast.next({ message, type, title });
    }
  }

  // loader (action: 'start' | 'stop') {
  //   this.showLoader.next(action === 'start');
  // }

  loader(action: 'start' | 'stop') {
    if (action === 'start') {
      window.parent.postMessage({
        type: 'SHOW_LOADER'
      }, '*');
    } else {
      setTimeout(() => {
        window.parent.postMessage({
          type: 'STOP_LOADER'
        }, '*');
      }, 2000);
    }
  }

  toTitleCase (str: string) {
    return (str || '').toLowerCase()
      .replaceAll('_', ' ')
      .replace(/(^|\s)\w/g, (match) => match.toUpperCase());
  }

  updatePlatformDirection(language: string) {
    if (['ar', 'he', 'fa'].includes(language)) {

      document.documentElement.setAttribute('dir', 'rtl');
      this.platformDirection = 'rtl';
    } else {
      document.documentElement.removeAttribute('dir');
      this.platformDirection = 'ltr';
    }
  }
}
